import { Check } from 'lucide-react';
import { Button } from '@/ui/Button';
import { cn } from '@/lib/utils';

interface PricingTierProps {
  name: string;
  price: string;
  pricePeriod?: string;
  description: string;
  features: string[];
  buttonText: string;
  highlighted?: boolean;
  onButtonClick: () => void;
}

export function PricingTier({
  name,
  price,
  pricePeriod = "/ month",
  description,
  features,
  buttonText,
  highlighted,
  onButtonClick
}: PricingTierProps) {
  return (
    <div className={cn("flex flex-col h-full font-mono p-8 md:p-12", highlighted ? "relative" : "")}>
      <div className="mb-10">
        <h3 className="text-lg font-bold uppercase tracking-wider mb-6">{name}</h3>
        <div className="flex items-baseline gap-2 mb-4">
            <span className="text-5xl font-bold tracking-tighter">{price}</span>
            <span className="text-sm text-muted-foreground">{pricePeriod}</span>
        </div>
        <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
      </div>

      <div className="flex-grow mb-10">
        <ul className="space-y-4">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start gap-3">
              <Check className="h-4 w-4 text-neutral-950 dark:text-neutral-100 flex-shrink-0 mt-1" />
              <span className="text-sm text-muted-foreground">{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <Button
          className={cn(
            "w-full h-14 rounded-none font-bold text-sm uppercase tracking-widest transition-all border-2",
            highlighted
              ? "bg-neutral-950 text-white hover:bg-neutral-800 border-neutral-950 dark:bg-white dark:text-black dark:border-white dark:hover:bg-neutral-200"
              : "bg-transparent text-foreground hover:bg-neutral-100 dark:hover:bg-neutral-900 border-neutral-950 dark:border-neutral-100"
          )}
          onClick={onButtonClick}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
}
